import React, { useEffect, useState } from 'react';
import './Order.css';
import { useNavigate } from 'react-router-dom';
import { useApiServices } from '../../services/endpoints/ApiEndpoint';
import { formatDateWithTime } from '../../utils/helper';

const Order: React.FC = () => {
  const navigate = useNavigate();
  const { GetTransactionAsync } = useApiServices()
  const [orders, setOrders] = useState<any>([])
  const [orderGrouped, setOrderGrouped] = useState<any[]>([])

  useEffect(() => {
    GetTransactionAsync().then(response => {
      if (response.isSuccess) {
        setOrders(response.result.items)
      }
    })
  }, [])

  useEffect(() => {
    const groupedOrders: any[][] = [];
    const seenGroupKeys = new Map<string, any[]>();

    orders.forEach((order: any) => {
      const groupKey = order.groupKey;
      if (groupKey) {
        if (seenGroupKeys.has(groupKey)) {
          seenGroupKeys.get(groupKey)!.push(order);
        } else {
          const newGroup = [order];
          seenGroupKeys.set(groupKey, newGroup);
          groupedOrders.push(newGroup);
        }
      } else {
        groupedOrders.push([order]);
      }
    });
    setOrderGrouped(groupedOrders)
  }, [orders])

  return (
    <section className="or-wrapper">
      <div className="or-container lg:container lg:mx-auto">
        <h1 className="or-title">ประวัติการสั่งซื้อ</h1>

        {orderGrouped.length === 0 && (
          <div className="or-empty">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2"/>
              <rect x="9" y="3" width="6" height="4" rx="1"/>
              <path d="M9 12h6M9 16h4"/>
            </svg>
            <p className="or-empty-text">ยังไม่มีคำสั่งซื้อ</p>
          </div>
        )}

        {orderGrouped.map((group, index) => {
          const first = group[0];
          const isGrouped = group.length > 1;
          const allProducts = group.flatMap((o: any) => o.transactionToProducts);
          const totalPrice = allProducts.reduce((sum: any, p: any) => sum + p.price * p.quantity, 0);
          const totalShipping = group.reduce((sum: any, o: any) => sum + (o.shippingPrice || 0), 0);
          const transactionIds = group.map((o: any) => o.id);
          const transactionNumbers = group.map((o: any) => o.transactionNumber);
          const sortedNumbers = [...transactionNumbers].sort();
          const displayTransactionNumber = isGrouped
            ? `${sortedNumbers[0]} - ${sortedNumbers[sortedNumbers.length - 1].slice(-3)}`
            : first.transactionNumber;

          return (
            <div
              key={`group-${index}`}
              className="or-card"
              onClick={() => navigate(isGrouped ? `/order/${transactionIds.join(',')}` : `/order/${first.id}`)}
            >
              {/* Status banner */}
              <div className="or-status-banner" style={{ backgroundColor: first.status?.color }}>
                {first.status?.labelTh}
              </div>

              {/* Header */}
              <div className="or-header">
                <div className="or-header-info">
                  <span className="or-order-number">#{displayTransactionNumber}</span>
                  <span className="or-order-date">{formatDateWithTime(first.createDate)}</span>
                </div>
                <svg className="or-chevron" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M6 4l4 4-4 4"/>
                </svg>
              </div>

              {/* Products */}
              <div className="or-products">
                {allProducts.map((p: any, i: number) => (
                  <div key={`p-${i}`} className="or-product-row">
                    <span className="or-product-name">{p.product?.nameTh}</span>
                    <div className="or-product-meta">
                      <span className="or-product-qty">x{p.quantity}</span>
                      <span className="or-product-price">{p.price.toLocaleString()} บาท</span>
                    </div>
                  </div>
                ))}
              </div>

              {/* Footer totals */}
              <div className="or-footer">
                <div className="or-footer-row">
                  <span>ราคาสินค้า</span>
                  <span>{totalPrice.toLocaleString()} บาท</span>
                </div>
                {totalShipping > 0 && (
                  <div className="or-footer-row">
                    <span>ค่าขนส่ง</span>
                    <span>{totalShipping.toLocaleString()} บาท</span>
                  </div>
                )}
                <div className="or-footer-total">
                  <span>ยอดรวมชำระ</span>
                  <span className="or-total-price">{(totalPrice + totalShipping).toLocaleString()} บาท</span>
                </div>
              </div>
            </div>
          );
        })}

      </div>
    </section>
  )
}

export default Order;
